import "./text-area.scss";
import { Fragment } from "react";
import { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";

import { createUUID } from "../../../shared/utils/utils";
import { roleRead } from "../../constants/user-roles";
import AuthContext from "../../context/auth-context";

export interface InputConfig {
  id: string;
  label?: string;
  required: boolean;
  inputKey: string;
  disabled?: boolean;
  mode?: string;
  placeholder?: string;
  autofocus?: boolean;
  defaultValue?: string;
  toggleWarning?: boolean;
  noRoleCheck?: boolean;
  extraClass?: string;
  onFocusEmpty?: boolean;
  extraId?: string;
  generateUniqueId?: boolean;
  size?: "small" | "large";
  handleOnChange(newValue: string, key?: string, id?: string, extraId?: string): void;
  handleOnFocus?(): void;
  handleOnBlur?(): void;
}

const TextArea = ({
  id,
  label,
  required,
  inputKey,
  disabled,
  mode,
  defaultValue,
  placeholder,
  autofocus,
  toggleWarning,
  noRoleCheck,
  extraClass,
  generateUniqueId,
  extraId,
  size = "small",
  handleOnChange,
  handleOnFocus,
  handleOnBlur,
}: InputConfig) => {
  const [readOnlyState, setReadOnlyState] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (authCtx.selectedTenant.roles) {
      const rolesArray = authCtx.selectedTenant.roles;
      if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1 && !noRoleCheck) {
        setReadOnlyState(true);
      } else {
        setReadOnlyState(false);
      }
    }
  }, [authCtx.selectedTenant.roles]);

  const onChangeStatus = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleOnChange(e.target.value, inputKey, id, extraId);
  };

  return (
    <div className={`textAreaInput ${inputKey} ${extraClass}`}>
      <Form.Group className="textAreaInput-group has-validation" controlId={generateUniqueId? createUUID() : id}>
        {label ? (
          <span className={mode === "aside" ? "textAreaInput-aside-label" : ""}>
            <Form.Label>
              {label}
              {required ? " *" : ""}
            </Form.Label>
          </span>
        ) : (
          ""
        )}
        <Fragment>
          <Form.Control
            className={(toggleWarning ? "is-invalid" : "") + (mode === "aside" ? "textAreaInput-aside" : "") + (size === "large" ? " textInput-large" : "")}
            as={"textarea"}
            disabled={readOnlyState || disabled}
            placeholder={placeholder}
            required={required}
            autoFocus={autofocus}
            rows={size === "large" ? 14 : 3}
            value={defaultValue}
            onChange={onChangeStatus}
            onBlur={() => handleOnBlur && handleOnBlur()}
            onFocus={() => handleOnFocus && handleOnFocus()}
            autoComplete="off"
            readOnly={readOnlyState}
          />
        </Fragment>

        <Form.Control.Feedback type="invalid">{`Please provide the ${label}`}</Form.Control.Feedback>
      </Form.Group>
    </div>
  );
};

export default TextArea;